export default {
  loading: false,
  batches: {},
  list: {},
  listHistory: {},
  selectedAuction: {},
  selectedAuctionBatches: {},
  pagination: {
    items: 0,
    pages: 0
  },
};
